import $ from "jquery";

export function createHeightTouchspin(selector, prefix = undefined, min = 0, max = 9999999, postfix = 'cm', step = 10) {
  var elem = $(selector);
  var opts = {
    initval: min,
    min: min,
    max: max,
    decimals: 0,
    //step: step,
    step: 0,
    boostat: 5,
    maxboostedstep: 10,
    verticalbuttons: true,
    prefix: prefix,
    postfix: postfix,
    forcestepdivisibility: 'none',
  };
  $(selector).TouchSpin(opts);
}
